import styles from './styles.module.css';
import defaultImg from 'src/assets/images/header_wallpaper.avif';


interface HeaderProp {
    title: string,
    img?: string
}

const Header = ({ title, img }: HeaderProp) => {
    return (
        <div className={styles.container}>
            <img src={img || defaultImg} alt="Header Image" />
            <div className={styles.overlay}>
                <h1 className={styles.title}>
                    {title}
                </h1>
            </div>
        </div>
    )
}

export default Header;